/**
 * Wraps text into multiple lines to fit within a specified width
 * @param {string} text - The text to wrap
 * @param {number} maxWidth - Maximum width in points
 * @param {number} fontSize - Font size in points
 * @param {PDFFont} font - PDF font object from pdf-lib
 * @returns {string[]} Array of text lines
 */
export const wrapText = (text, maxWidth, fontSize, font) => {
  const textStr = String(text);
  if (!textStr || textStr === '-') return [textStr];
  
  const words = textStr.split(' ');
  const lines = [];
  let currentLine = '';

  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    const testLine = currentLine ? `${currentLine} ${word}` : word;
    const testWidth = font.widthOfTextAtSize(testLine, fontSize);

    if (testWidth <= maxWidth) {
      currentLine = testLine;
    } else {
      if (currentLine) {
        lines.push(currentLine);
        currentLine = word;
      } else {
        // Word is too long, break it
        let remainingWord = word;
        while (remainingWord.length > 0) {
          let charCount = 1;
          while (charCount <= remainingWord.length) {
            const testChar = remainingWord.substring(0, charCount);
            const charWidth = font.widthOfTextAtSize(testChar, fontSize);
            if (charWidth > maxWidth) {
              if (charCount > 1) {
                lines.push(remainingWord.substring(0, charCount - 1));
                remainingWord = remainingWord.substring(charCount - 1);
              } else {
                lines.push(remainingWord.substring(0, 1));
                remainingWord = remainingWord.substring(1);
              }
              break;
            }
            charCount++;
          }
          if (charCount > remainingWord.length) {
            lines.push(remainingWord);
            remainingWord = '';
          }
        }
        currentLine = '';
      }
    }
  }

  if (currentLine) {
    lines.push(currentLine);
  }

  return lines.length > 0 ? lines : [textStr];
};

